import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { getIntlPhoneNumber } from 'utils/phone.utils';

declare global {
	namespace JSX {
		interface IntrinsicElements {
			'lxl-app-contact-form': React.DetailedHTMLProps<any, any>;
		}
	}
}

function FormContactUs() {
	const progressIndicator = useSelector(
		(state: RootState) => state.progressIndicator,
	);
	const { profile } = useSelector((store: RootState) => store.user);
	const { locationFields } = useSelector(
		(store: RootState) => store.locationInformation,
	);
	let payload;
	if (locationFields.email) {
		payload = {
			name: { value: profile?.givenName, readonly: true },
			surname: { value: profile?.familyName, readonly: true },
			email: { value: locationFields.email, readonly: true },
			store: { value: profile?.location, readonly: true },
			telephone: {
				value: getIntlPhoneNumber(
					locationFields.phoneNumber,
					locationFields.country ? locationFields.country : 'IT',
				),
				readonly: true,
			},
		};
	}

	return progressIndicator?.isLoading || !payload ? (
		<></>
	) : (
		<lxl-app-contact-form
			id="form"
			brand="EM"
			country="IT"
			locale="IT"
			payload={JSON.stringify(payload)}
		></lxl-app-contact-form>
	);
}

export default FormContactUs;
